exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading[data-v-065eb308] {\n    padding: 12px;\n    text-align: center;\n}\n.message.warning[data-v-065eb308] {\n    margin: 12px;\n}\n", ""]);

// exports
